module.exports = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://app.fazendoacontecer.org.br/api'
}